import { createContext } from 'react';
import { UnitHistoryState } from './types';

export const UnitHistoryContext = createContext<undefined | UnitHistoryState>(undefined);
